import type { PropsWithChildren } from 'react';

import { useIsVisibleInViewport } from '#src/hooks/ui/useIsVisibleInViewport.ts';

export const DisplayIfVisible = ({ children }: PropsWithChildren) => {
  const { handleRef, hasBeenVisible } =
    useIsVisibleInViewport<HTMLDivElement>();

  if (!hasBeenVisible) {
    return <div ref={handleRef} />;
  }
  return <>{children}</>;
};
